export default __webpack_public_path__ + "static/media/No.6-9.e5e0d01d.jpg";